import MatchRow from "./matchRow";
import "./matchDaySection.sass";

export default function MatchDaySection({ groupId, day, onChangeScore }) {
  return (
    <div className="DaySection">
      <div className="DayHeader">{day.dateText}</div>

      {day.matches.map((m) => (
        <MatchRow 
          key={m.id} 
          match={m} 
          groupId={groupId} 
          onChangeScore={onChangeScore} 
        />
      ))}
    </div>
  );
}